import { render, staticRenderFns } from "./UsersDashboard.vue?vue&type=template&id=2fd35855&scoped=true&"
import script from "./UsersDashboard.vue?vue&type=script&lang=js&"
export * from "./UsersDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd35855",
  null
  
)

export default component.exports